<app-layout>
    <h1 class="mb-8 font-bold text-3xl">Users</h1>
    <div class="mb-6 flex justify-between items-center">
        <search-filter v-model="form.search" class="w-full max-w-md mr-4 focus:outline-none" @reset="reset">

        </search-filter>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
        <table class="w-full whitespace-no-wrap">
            <tr class="text-left font-bold">
                <th class="px-6 pt-6 pb-4">ID</th>
                <th class="px-6 pt-6 pb-4">Email</th>
                <th class="px-6 pt-6 pb-4">Registered Date</th>
                <th class="px-6 pt-6 pb-4">KYC Status</th>
                <th class="px-6 pt-6 pb-4">Email Status</th>
                <th class="px-6 pt-6 pb-4">User Status</th>
            </tr>
            <tr v-for="user in users.data" :key="user.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t">
                    <inertia-link class="px-6 py-4 flex items-center text-indigo-500" :href="route('admin.users.edit', user.id)">
                        {{ user.id }}
                    </inertia-link>
                </td>
                <td class="border-t">
                    <inertia-link class="px-6 py-4 flex items-center text-indigo-500" :href="route('admin.users.edit', user.id)">
                        {{ user.email }}
                    </inertia-link>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center">
                        {{ user.created_at }}
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center focus:text-indigo-500">

                        <badge class="mr-2" :type="user.kyc_verified_at ? 'green' : 'gray'">
                            {{ user.kyc_verified_at ? 'Verified' : 'Unverified' }}
                        </badge>
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center focus:text-indigo-500">

                        <badge class="mr-2" :type="user.email_verified_at ? 'green' : 'gray'">
                            {{ user.email_verified_at ? 'Verified' : 'Unverified' }}
                        </badge>
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center focus:text-indigo-500">

                        <badge class="mr-2" :type="!user.deactivated ? 'green' : 'gray'">
                            {{ !user.deactivated ? 'Active' : 'Blocked' }}
                        </badge>
                    </span>
                </td>
            </tr>
            <tr v-if="users.data.length === 0">
                <td class="border-t px-6 py-2" colspan="100">No users found.</td>
            </tr>
        </table>
    </div>

    <pagination :links="users.links" />
</app-layout>
